import React from "react";
import "./inputfield.css";

function InputField(props) {
  // console.log(props.onChange, "line 5");
  return (
    <div className="label_input_text_contianer">
      <p className="input_label_text">{props.headTextInput}</p>
      <input
        type={props.inputType}
        placeholder={props.placeholderText}
        id={props.inputId}
        name={props.nameText}
        autoComplete="off"
        required
        className="input_dialog_style"
        patterns={props.inputPattern}
        onChange={props.onChange}
      />
    </div>
  );
}

export default InputField;
